import {graphql} from 'gatsby'
import React from 'react'

import type {VideoPopoverWithTextSliceFragment} from '@/graphql-types'
import {VideoPopoverWithText} from '@/sections/video-popover-with-text'

type Props = {
    slice: VideoPopoverWithTextSliceFragment
    dataTestId?: string
}

export const VideoPopoverWithTextSlice = ({slice, dataTestId}: Props) => {
    const {pre_title, title, body_text, wistia_video_id, video_mp4, video_webm} = slice.primary

    return (
        <VideoPopoverWithText
            preTitle={pre_title}
            title={title}
            body={body_text}
            videoId={wistia_video_id}
            dataTestId={dataTestId}
            thumbnailVideo={{
                mp4: video_mp4.url,
                webm: video_webm.url,
            }}
        />
    )
}

export const videoPopoverWithTextSliceFragment = graphql`
    fragment VideoPopoverWithTextSlice on PrismicSlicePageDataBodyVideoPopoverWithText {
        __typename
        id
        primary {
            pre_title
            title
            body_text
            wistia_video_id
            video_mp4 {
                url
            }
            video_webm {
                url
            }
        }
    }
`
